<div class="datepicker-label" [ngClass]="{'error': showError}">{{datePickerInput.datePickerLabel}}</div>
<button  aria-live="polite" id="{{datePickerInput.id}}" class='date-input-text' (click)="toggle($event)" [ngClass] = "{'field-disabled' : datePickerInput.disable, 'error': showError}" tabindex="0" (keyup)="keyUp($event)">
  <i class="icon_calendar" [attr.aria-label]="(datePickerInput.disable ? 'calendar for ' + datePickerHeading + ' is disabled' : ( showCalendar ? 'Close calender for '+ datePickerHeading + ' for date ' : 'Open calender for '+ datePickerHeading + ' for date ') )"></i>
  <span>{{dateLabel}}</span>
</button>
<div class="calendar" *ngIf='showCalendar'>
  <div class="date-picker">
    <table role="presentation">
      <thead>
        <tr>
          <td colspan="1" class="next">
            <button [disabled] = "disableDown" (click)=refreshView(-1) class="left-chevron"  aria-label="Go to previous month">
              <i class="icon-left arrow" [ngClass] = "{'icon-disabled' : disableDown}"></i>
            </button>
          </td>
          <td colspan="5" class="month-label">{{monthLabel}}</td>
          <td colspan="1" class="next">
            <button [disabled] = "disableUp" (click)=refreshView(1) class="right-chevron"  aria-label="Go to next month">
              <i class="icon-right arrow" [ngClass] = "{'icon-disabled' : disableUp}"></i>
            </button>
          </td>
        </tr>
        <tr>
          <td *ngFor="let day of weekLabels" class="week-label">{{day}}</td>
        </tr>
      </thead>
      <tbody tabindex="0" [attr.aria-label]="monthLabel + 'Table'">
        <tr *ngFor="let week of rows; let weekIndex=index" role="listbox">
          <td *ngFor="let date of week;let day=index">
            <button *ngIf="date.selected" (click)=selectDate(date,weekIndex,day) role="option" [attr.aria-label]="date.label+' '+monthLabel+' '+'Selected'" [hidden]="date.secondary" [disabled]="date.disabled" [ngClass] = "{'disabled' : date.disabled, 'selected' : date.selected}" class="day-label">{{date.label}}</button>
            <button *ngIf="!date.selected" (click)=selectDate(date,weekIndex,day) role="option" [attr.aria-label]="date.label+' '+monthLabel+' '+'Not selected'" [hidden]="date.secondary" [disabled]="date.disabled" [ngClass] = "{'disabled' : date.disabled, 'selected' : date.selected}" class="day-label">{{date.label}}</button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="legend-container">
      <div class="legend-selected"></div>
      <div class="legend-text"> Selected Date</div>
    </div>
  </div>
</div>

